import { X } from "lucide-react";
import React from "react";

const VerificationMessage = ({
  onClose,
  email,
}: {
  onClose: () => void;
  email: string;
}) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl max-w-md w-full p-6">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-xl font-bold">Verify Your Email</h3>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
        <div className="space-y-4">
          <p>
            We've sent a verification link to{" "}
            <span className="font-semibold">{email}</span>. Please check your
            email and click the link to verify your account.
          </p>
          <p>
            If you didn't receive the email, check your spam folder or request a
            new verification email.
          </p>
          <div className="flex justify-end space-x-3 pt-4">
            <button
              onClick={onClose}
              className="px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-50"
            >
              Close
            </button>
            <button
              onClick={() => {
                // TODO: Implement resend verification email
                alert("Resend verification email functionality would go here");
              }}
              className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
            >
              Resend Email
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerificationMessage;
